if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this.cartButton = this.querySelector('[data-product-card-add]');
        if (!this.cartButton) return;

        this.wasLoading = false;
        this.onButtonStateChange = this.onButtonStateChange.bind(this);

        this.observer = new MutationObserver(this.onButtonStateChange);
        this.observer.observe(this.cartButton, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      onButtonStateChange() {
        const isLoading = this.cartButton.classList.contains('loading');

        if (!isLoading && this.wasLoading) {
          this.cartButton.classList.add('product-card__cart-btn--added');
          window.clearTimeout(this.addedTimeout);
          this.addedTimeout = window.setTimeout(() => {
            this.cartButton.classList.remove('product-card__cart-btn--added');
          }, 1200);
        }

        this.wasLoading = isLoading;
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.clearTimeout(this.addedTimeout);
      }
    }
  );
}
